import { registerStorageTreeExtension } from '../../../database-objects/services/storageTreeExtensions';
import { registerS2StorageToolbarExtensions } from './s2ToolbarExtensions';
import { s2ServiceFolderActionRows } from './serviceFolderActions';
import { s2MenuItems } from './treeMenuItems';

export function registerS2StorageTreeExtension(): () => void {
  return registerStorageTreeExtension({ id: 's2-mutations', slice: 's2', menuItems: s2MenuItems, serviceFolderActionRows: s2ServiceFolderActionRows });
}

export function registerS2StorageMutationExtensions(): () => void {
  const unregisterToolbar = registerS2StorageToolbarExtensions();
  const unregisterTree = registerS2StorageTreeExtension();
  return () => { unregisterToolbar(); unregisterTree(); };
}

export { StorageCreateContainerDialog } from './StorageCreateContainerDialog';
